/** URL de registro con código prellenado (QR / compartir). */
export function buildInviteRegisterUrl(code) {
  const trimmed = String(code || '').trim();
  if (!trimmed) return '';
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const params = new URLSearchParams({ code: trimmed, entry: 'invite' });
  return `${origin}/?${params.toString()}`;
}
